import React from 'react';
import { Link } from "react-router-dom"

import App from '../App'
import Nav from './Nav'


class UserSettings extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		this.titleText = React.createRef()
		this.descriptionText = React.createRef()
		this.referralText = React.createRef()
		// this.referralExtraInputVisible = React.createRef()
		this.referralExtraInputTitle = React.createRef()


	}

	async componentDidMount() {
		this.setState({ 'referralExtraInputVisible': this.props.appState.currentUserData ? this.props.appState.currentUserData.referralExtraInputTitle : false })
	}

	async componentDidUpdate(prevProps) {
		try {
			if (prevProps.appState !== this.props.appState) {
				this.setState({ 'referralExtraInputVisible': this.props.appState.currentUserData ? this.props.appState.currentUserData.referralExtraInputTitle : false })
			}
		} catch (e) {
		}
	}


	handleSubmit = async (event) => {
		event.preventDefault()
		console.log(this.descriptionText.current.value)

		try {
			this.setState({ error: null })

			if (!this.titleText.current.value) throw 'Please enter a title text'
			if (!this.descriptionText.current.value) throw 'Please enter a description text'

			await App.currentUserDoc(this.props.appState.currentUser.uid).update({
				titleText: this.titleText.current.value,
				descriptionText: this.descriptionText.current.value,
				referralText: this.referralText.current.value,
				referralExtraInputTitle: this.state.referralExtraInputVisible ? this.referralExtraInputTitle.current.value : null,
			})

			this.props.history.push('/')

		} catch (e) {
			console.log(e.message || e);
			this.setState({ error: e.message || e })
		}
	}



	render() {
		return (
			<>
				<Nav {...this.props} ></Nav>

				<div class="container py-5">

					{this.props.appState.currentUserData === undefined &&
						<div class="my-5 py-5 text-center"><div class="spinner-border "></div></div>
					}

					{this.props.appState.currentUserData &&
						<div>

							<div class="h6 text-center my-4 ">
								<img class="profile-pic mr-2 rounded-circle" src={this.props.appState.currentUserData.photoURL} />
								{this.props.appState.currentUserData.twitterUsername}
							</div>
							<div className="h4 text-center my-4 ">Settings</div>


							<form onSubmit={this.handleSubmit} class="my-5  max30">
								<div class="form-group">
									<label htmlFor="titleText" class="small text-uppercase text-muted">Title Text</label>
									<input type="text" class="form-control" id="titleText" rows="3" ref={this.titleText} defaultValue={this.props.appState.currentUserData.titleText || this.props.appState.currentUserData.twitterUsername} />
								</div>
								<div class="form-group">
									<label htmlFor="descriptionText" class="small text-uppercase text-muted">Description Text</label>
									<textarea type="text" class="form-control" id="descriptionText" rows="3" ref={this.descriptionText} defaultValue={this.props.appState.currentUserData.descriptionText} />
								</div>

								<div class="form-group mt-4">
									<label htmlFor="referralText" class="small text-uppercase text-muted">Referral Text</label>
									<textarea type="text" class="form-control" id="referralText" rows="3" ref={this.referralText} defaultValue={this.props.appState.currentUserData.referralText || "Share this link with others and you'll get credit for anyone who signs up from it."} />
								</div>

								{/* <div class="form-check mb-2">
									<input class="form-check-input" type="checkbox" id="referralExtraInputToggle" checked={this.state.referralExtraInputVisible} onChange={(e) => { this.setState({ 'referralExtraInputVisible': e.target.checked }) }} />
									<label class="form-check-label text-muted" htmlFor="referralExtraInputToggle">Capture extra info for referral bonus<br />(Optional. Eg: BTC Address)</label>
								</div>
								{this.state.referralExtraInputVisible &&
									<div class="form-group">
										<label htmlFor="referralExtraInputTitle" class="small text-uppercase text-muted">Extra Info Input Title</label>
										<input type="text" class="form-control" id="referralText" ref={this.referralExtraInputTitle} defaultValue={this.props.appState.currentUserData.referralExtraInputTitle} />
									</div>
								} */}


								<div class="small text-danger text-center my-4 ">{this.state.error}</div>
								<div class=" my-5">
									<button type="submit" class="btn btn-dark btn-block text-capitalize">Save</button>
								</div>
							</form>


						</div>
					}


				</div>
			</>
		)
	}


}

export default UserSettings
